<template>
	<div class="labelSelect" :style="{width:componentWidth}">
		<span :style="{color:spanColor,fontSize:spanFontSize+'px',width:spanWidth,}" class="innerSpan">
			<span style="color: red;" v-if="spanRequired">*&nbsp;</span>
			{{spanTitle}}:
		</span>
		<div class="innerP">
			<div :style="{width: selectWidth}">
				<el-date-picker v-model="value" @change="selectChange" :type="pickerType" :placeholder="pelaceHolder" 
				:format="format" :value-format="valueformat">
				</el-date-picker>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 预设值放置在value中 v-model'动态绑定'
				value: '',
			}
		},
		computed: {
			selectWidth() {
				// let licaoWidth = parseInt(100 / this.selectList.length - 1) + '%'
				// console.log(licaoWidth)
				// return licaoWidth
				return '100%'
			},
			format(){
				if(this.pickerType === 'year'){
					return 'yyyy 年'
				}else if(this.pickerType === 'month'){
					return 'yyyy 年 MM 月'
				}
				return 'yyyy 年 MM 月 dd 日'
			},
			valueformat(){
				if(this.pickerType === 'year'){
					return 'yyyy'
				}else if(this.pickerType === 'month'){
					return 'yyyy-MM'
				}
				return 'yyyy-MM-dd'
			}
		},
		props: {
			// 默认组件宽度
			componentWidth: {
				type: String,
				default: '600px'
			},
			// span类
			spanColor: {
				type: String,
				default: '#000'
			},
			spanFontSize: {
				type: Number,
				default: 14
			},
			spanTitle: {
				type: String,
				default: '标题'
			},
			spanWidth: {
				type: String,
				default: '100px'
			},
			// 限制必填
			spanRequired: {
				type: Boolean,
				default: false
			},
			// pelaceHolder提示
			pelaceHolder: {
				type: String,
				default: '请选择'
			},
			// 时间选择器的类型
			pickerType:{
				type:String,
				default:'date'
			},
			
			dataList: {
				type: Array,
				default: () => {
					return []
				}
			},
			// 绑定外部值
			outInput: {
				type: String,
				default: ''
			}
		},
		watch: {
			outInput(newvalue) {
				this.value = newvalue
				this.$emit('selectDate',newvalue)
			}
		},
		created() {

		},
		methods: {
			selectChange(e) {
				// console.log(e)
				this.$emit('selectDate',e)
			}
		}
	}
</script>

<style>
	.el-date-editor.el-input, .el-date-editor.el-input__inner{
		width: 100%;
	}
	.labelSelect {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		margin: 10px 10px;
	}

	.innerSpan {
		display: inline-block;
	/*	display: inherit;*/
		justify-content: flex-end;
		text-align: left;
	}

	.innerP {
		display: inline-block;
		display: inherit;
		justify-content: space-between;
		/* justify-content: flex-start; */
		padding-left: 20px;
	}
</style>
